import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { baseURL } from 'src/app/core/constants/base.url';
import { DashboardSummary } from '../interface/dashboard';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  // =====================================
  // DASHBOARD SUMMARY
  // =====================================

  getDashboardSummary(): Observable<any> {

    return this.http.get(

      `${baseURL}dashboard/summary`

    );

  }

  // =====================================
  // RECENT INVOICES
  // =====================================

  getRecentInvoices(): Observable<any> {

    return this.http.get(

      `${baseURL}dashboard/recent-invoices`

    );

  }

  // =====================================
  // LOW STOCK PRODUCTS
  // =====================================

  getLowStockProducts(): Observable<any> {

    return this.http.get(
      `${baseURL}dashboard/low-stock`
    );

  }

}